// Pure helpers behind the group page's tournament cards and yearly
// leaderboard. Input is the row shape get_group_brackets returns.

export function tournamentTiming(startDate, endDate, now = new Date()) {
  const start = startDate ? new Date(startDate) : null
  const end = endDate ? new Date(endDate) : null
  if (end && now > end) return 'past'
  if (start && now < start) return 'upcoming'
  return 'live'
}

// One entry per tournament, ordered like Home's "My Tournaments": live first,
// then upcoming, then the most recently finished.
export function groupBracketsByTournament(brackets, now = new Date()) {
  const byId = new Map()
  for (const b of brackets || []) {
    if (!byId.has(b.tournament_id)) {
      byId.set(b.tournament_id, {
        id: b.tournament_id,
        name: b.tournament_name,
        startDate: b.tournament_start_date,
        endDate: b.tournament_end_date,
        bracketIds: [],
      })
    }
    byId.get(b.tournament_id).bracketIds.push(b.bracket_id)
  }
  const order = { live: 0, upcoming: 1, past: 2 }
  return [...byId.values()]
    .map(t => ({ ...t, timing: tournamentTiming(t.startDate, t.endDate, now) }))
    .sort((a, b) => {
      if (order[a.timing] !== order[b.timing]) return order[a.timing] - order[b.timing]
      if (a.timing === 'upcoming') return new Date(a.startDate) - new Date(b.startDate)
      return new Date(b.endDate || 0) - new Date(a.endDate || 0)
    })
}

// get_leaderboard_rankings files a tournament under the year it ended
// (falling back to its start), so the options use the same rule. The current
// year is always offered: on January 1 it is the fresh, empty board.
export function leaderboardYears(brackets, now = new Date()) {
  const years = new Set([now.getFullYear()])
  for (const b of brackets || []) {
    const d = b.tournament_end_date || b.tournament_start_date
    if (d) years.add(new Date(d).getFullYear())
  }
  return [...years].sort((a, b) => b - a)
}

// The dub Champ(s) of a finished tournament: everyone tied at rank 1, as long
// as someone actually scored.
export function champsFromLeaderboard(rows) {
  return (rows || []).filter(r => Number(r.rank) === 1 && Number(r.total_points) > 0)
}
